export const environment = {
  production: false,
  api: `https://worklog-dev.odds.team/api/`,
};
